/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 14/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { CalibracionProvider } from "./CallibracionContext";
export const AllFormsProyectProvider = (props) => (
    <CalibracionProvider>
        {props.children}
    </CalibracionProvider>
);
